<template>
  <div :class="[baseClass, activeClass]" @click="setFreeSearchListActive(true)">
    <div class="flex-column full-h">
      <freeSearchProgress
        v-show="isSearching"
        :percent="percent"
        :search="rawSearchTxt"
        :seconds="seconds"
        :stopAnimation="stopAnimation"
        @stop="stopFreeSearch()"
        :message="$t('freeSearchResults.reloadResults')"
      />

      <div class="h-100">
        <freeSearchListHeaderContainer
          @search="searchInList"
          @checkall="checkAll"
          :searchTxt="searchTxt"
          :searchId="searchId"
        />
        <freeSearchListBookContainer
          :search="searchTxt"
          :mefo="mefo"
          @scrollToSec="
            (v) => {
              $emit('scrollToSec', v);
            }
          "
          :searchId="searchId"
        />
      </div>
    </div>
  </div>
</template>

<script>
import freeSearchProgress from "@/components/listBookArea/freeSearchBarContainer/freeSearchProgress.vue";
import freeSearchBarContainer from "@/components/listBookArea/freeSearchBarContainer/freeSearchBarContainer.vue";
import freeSearchListHeaderContainer from "@/components/listBookArea/freeSearchBarContainer/freeSearchListHeaderContainer.vue";
import freeSearchListBookContainer from "./freeSearchBarContainer/freeSearchListBookContainer.vue";
import bookListHandle from "@/components/listBookArea/freeSearchBarContainer/bookListHandle.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import { stopFreeSearch } from "@/services/freeSearch.js";
import { createFreeSearchBookListStore } from "@/store_pinia";
export default {
  components: {
    freeSearchProgress,
    freeSearchBarContainer,
    freeSearchListHeaderContainer,
    freeSearchListBookContainer,
    bookListHandle,
  },
  data() {
    return {
      seconds: 0,
      interval: null,
      percent: 0,

      stopAnimation: false,
      searchTxt: "",
    };
  },
  props: {
    mefo: { default: false },
    searchId: { default: "main" },
  },
  watch: {
    searching: function (val) {
      if (val) {
        this.searchTxt = "";

        this.interval = setInterval(() => {
          this.seconds += 0.1;
          this.percent += 5;
          if (this.percent > 100) {
            this.percent = 0;
          }
        }, 100);
      } else {
        this.seconds = 0;
        this.percent = 0;
        clearInterval(this.interval);
        this.setSearchInTxt("");
      }
    },
  },
  computed: {
    ...mapState("freeSearch", ["searching"]),
    ...mapGetters("freeSearch", ["getSearchWords", "getSearchProgress"]),
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    showList() {
      return this.freeSearchBookListStore.showList;
    },
    searchInTxt() {
      return this.freeSearchBookListStore?.searchInTxt || "";
    },
    showListContainer() {
      return true;
      return this.freeSearchBookListStore.currentFsName != "";
    },
    rawSearchTxt() {
      return this.getSearchWords.words.map((w) => w.w).join(" ");
    },
    activeClass() {
      return this.freeSearchBookListStore?.active ? "active" : "";
    },
    baseClass() {
      return "listBookAreaContainer";
    },
    isSearching() {
      return this.searching;
    },
  },
  methods: {
    ...mapActions("freeSearch", ["setSearching"]),
    setFreeSearchListActive(val) {
      this.freeSearchBookListStore.active = val;
    },
    setSearchInTxt(val) {
      this.freeSearchBookListStore.searchInTxt = val;
    },
    stopFreeSearch() {
      this.setSearching(false);
      stopFreeSearch();
    },
    searchInList(search) {
      this.setSearchInTxt(search);
      this.searchTxt = search;
    },
    checkAll(check) {
      this.freeSearchBookListStore.checkAllBooks(check);
    },
  },
};
</script>

<style lang="scss" scoped>
.listBookAreaContainer {
  width: 100%;
  height: 100%;
  height: 100%;
  overflow: hidden;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  &::after {
    transition: 0.3s;
  }
  &.active::after {
    content: "";
    display: block;
    height: calc(100% - 3px);
    width: calc(100% - 3px);
    // border: 1.5px solid var(--custom-color1);
    position: absolute;
    top: 0;
    pointer-events: none;
    z-index: 1;
    transition: 0.3s;
  }
}
// .active {
//   border: 1px black solid;
// }
</style>
